import { render, staticRenderFns } from "./ClicTableColumnCustom.vue?vue&type=template&id=0b106b31&"
import script from "./ClicTableColumnCustom.vue?vue&type=script&lang=js&"
export * from "./ClicTableColumnCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports